module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_explore.77ec2cc9.png";